import { useGate } from 'statsig-react';

const useIsHoliday2024 = (): boolean => {
  return useGate('holiday_2024').value;
};

export default useIsHoliday2024;
